(function () {
    'use strict';

    angular
        .module('app.hbIntegration')
        .controller('HBEditMatchCategoryFilterController', HBEditMatchCategoryFilterController);

    HBEditMatchCategoryFilterController.$inject = ['$scope', '$stateParams', '$location', 'HBIntegrationService', 'NgTableParams'];

    function HBEditMatchCategoryFilterController($scope, $stateParams, $location, HBIntegrationService, NgTableParams) {
        /* jshint validthis:true */
        var vm = this;

        vm.settings = globalSettings;
        activate();

        function activate() {

            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function () {
                        return HBIntegrationService.hbgetMatchCategory($stateParams.Id)
                            .then(function (data) {
                                return HBIntegrationService.getCategoryFilter(data.IntegrationCategoryId)
                                    .then(function (result) {
                                        return result;
                                    });
                            });
                    }
                });

            HBIntegrationService.getOption().then(function (data) {
                vm.entity = getTreeData(data, null);
                vm.entity.refresh = true;
                vm.loading = false;
            });

            //GGIntegrationService.getMatchCategoryFilterListByCategory($stateParams.Id).then(function (data) {

            //});

            vm.MatchCategoryId = $stateParams.Id;

        }


        function getTreeData(options, topProp) {
            var data = options.filter(obj => obj["IconId"] === topProp);
            if (data.length <= 0) {
                return [];
            }
            return data
                .map(obj => {
                    var rObj = {};
                    rObj.id = obj["Id"];
                    rObj.name = obj["Name"];
                    rObj.children = getTreeData(options, obj.Id) || [];
                    return rObj;
                });
        }


        vm.selectFilter = function (filter) {
            vm.loading = true;
            vm.catAttr = {};
            vm.catAttr.OptionId = vm.item[0].id;
            vm.catAttr.MatchCategoryId = $stateParams.Id;
            vm.catAttr.IntegrationCategoryAttrId = filter.id;
            vm.catAttr.IntegrationCategoryAttrName = filter.name;
            HBIntegrationService.hbeditMatchCategoryFilter(vm.catAttr).then(function (data) {
                vm.loading = false;
                $location.path('/hbIntegration/hbeditmatchcategoryfiltervalue/' + data.Id);
            });
        };
    }
})();